import { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, useParams } from "react-router";
import SocketContext, {
  TeacherUpdateMessage,
} from "../../../context/socket-context";
import APIclient from "../../../api-client";
import {
  ObjectId,
  SessionStatus,
  Stored,
  StudentOpinion,
  PopulatedVotingSession,
} from "../../../types";
import { Session } from "./session.js";
import Results from "./results.js";
import logo from "../../../images/logo.png";
import StatementResult from "./statement";
import clsx from "clsx";
import Footer from "../../../components/footer";

export default function SessionWrapper() {
  const { code } = useParams();
  const location = useLocation();
  const socket = useContext(SocketContext);
  const [votingSession, setVotingSession] =
    useState<PopulatedVotingSession | null>(null);
  const [status, setStatus] = useState<SessionStatus>(SessionStatus.Draft);
  const [participants, setParticipants] = useState<number>(0);
  const [answers, setAnswers] = useState<Array<Stored<StudentOpinion>>>([]);
  const isResult = location.pathname.endsWith("results");

  useEffect(() => {
    if (code === undefined) return;

    APIclient.sessions.participants(code).then(setParticipants);
    APIclient.sessions.read(code).then((session) => {
      setStatus(session.state);
      setVotingSession(session);
      setAnswers(session.studentOpinions);
    });
  }, [code]);

  useEffect(() => {
    if (code === undefined) return;

    socket.emit("subscribe", code);
    socket.on("participants", setParticipants);
    socket.on("teacherUpdate", handleMessage);
  }, [socket, code]);

  function handleMessage(message: TeacherUpdateMessage) {
    switch (message.type) {
      case "student-answered":
        setAnswers((arr) => [
          ...arr.filter((a) => a._id !== message.studentOpinion._id),
          message.studentOpinion,
        ]);
    }
  }

  async function toggleComment(answerID: ObjectId, hidden: boolean) {
    setAnswers((arr) =>
      arr.map((answer) => {
        if (answer._id === answerID) answer.hidden = hidden;

        return answer;
      }),
    );
    await APIclient.opinions.update(answerID, hidden);
  }

  return (
    <>
      <main
        className={clsx("voting-session", {
          "voting-session--shrink": isResult,
        })}
      >
        <img src={logo} alt="" className="voting-session__logo" />
        {votingSession !== null && (
          <Routes>
            <Route
              index
              path=""
              element={
                <Session
                  votingSession={votingSession}
                  status={status}
                  setStatus={setStatus}
                  participants={participants}
                  answers={answers}
                  toggleComment={toggleComment}
                />
              }
            />
            <Route
              path="results"
              element={
                <Results votingSession={votingSession} answers={answers} />
              }
            />
            <Route
              path="results/:index"
              element={
                <StatementResult
                  votingSession={votingSession}
                  answers={answers}
                  toggleHiddenComment={toggleComment}
                />
              }
            />
          </Routes>
        )}
      </main>
      {isResult && <Footer />}
    </>
  );
}
